import { render } from "./storySlide.vue?vue&type=template&id=85ca0898"
import script from "./storySlide.vue?vue&type=script&lang=js"
export * from "./storySlide.vue?vue&type=script&lang=js"

import "./storySlide.vue?vue&type=style&index=0&id=85ca0898&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__